import React, { useState } from 'react';
import ModalWrapper from 'components/common/ModalWrapper';
import ButtonSmall from 'components/common/Buttons/ButtonSmall';
import {
  CleanScreenResultType,
  UrineDrugScreenDto,
} from '@peartherapeutics/hylia-api-client';
import ModalUrineDrugScreen from '../ModalUrineDrugScreen';
import styles from './styles.module.scss';

interface IButtonShowModalProps {
  urineDrugScreens: UrineDrugScreenDto[];
  arStartDate: string;
  arTimezone: string;
  addCleanScreenStatus: (param: {
    date: string;
    type: CleanScreenResultType;
  }) => void;
  'data-testid'?: string;
}

const ButtonShowModal = (props: IButtonShowModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = (isOpen: boolean) => () => setIsOpen(isOpen);

  return (
    <>
      <ButtonSmall
        buttonRole="dashboard"
        margin="5px 0 3px 0"
        handleClick={toggleModal(true)}
        data-testid={props['data-testid']}
      >
        Add Screen
      </ButtonSmall>
      <ModalWrapper
        isOpen={isOpen}
        className={styles['modal-wrapper']}
        onRequestClose={toggleModal(false)}
      >
        <ModalUrineDrugScreen
          hideModal={toggleModal(false)}
          modalIsOpen={isOpen}
          {...props}
        />
      </ModalWrapper>
    </>
  );
};

export default ButtonShowModal;
